export const getReviews = (state) => {
  const { results } = state.pages.homePage.reviews;
  return results;
};
